package nl.volleyanalyzer.web.controller

import kotlinx.browser.document
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.html.*
import kotlinx.html.dom.create
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.api.volleyanalyzer.PouleListResponse
import nl.volleyplanner.web.MainApp
import nl.volleyplanner.web.base.*
import nl.volleyplanner.web.launchAsync
import org.w3c.dom.HTMLElement

class AnalyzerIndexComponent(private val analyzerIndexFlow: StateFlow<PouleListResponse?>) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.div {
            if (analyzerIndexFlow.value == null) {
                spinner()
            } else {
                analyzerIndexFlow.value!!.items.forEach { item ->
                    div (classes = "row bg-secondary-subtle border-top p-2") {
                        div (classes = "col position-relative") {
                            a(classes = "stretched-link") {
                                href = "/poule/${item.fullPoule.pouleId}"
                                strong { +item.fullPoule.name }
                            }
                            br {}
                            span(classes = "small fw-lighter fst-italic text-secondary-emphasis") { +"${item.teams.joinToString(", ")}" }
                        }
                    }
                }
            }
        }
    }

    override suspend fun getState() = analyzerIndexFlow
}

class AnalyzerIndexController : RootPageController() {
    override val name = "AnalyzerIndexController"
    override val title = "Volleyanalyzer"
    override val path = ""
    override val requiredAuthLevel = AuthLevel.AnonymousPublic
    override val childPages: List<WebPageController> = listOf(PouleAnalyzerController(this))

    private val analyzerIndexFlow = MutableStateFlow<PouleListResponse?>(null)

    override fun createRuntimeInstance() = AnalyzerIndexController()

    override suspend fun renderContent(): HTMLElement {
        launchAsync {
            MainApp.volleyanalyzerApiClient.getAnalyzerPoules()
        }.onComplete { analyzerIndexFlow.value = it }
        return document.create.div {
            component(AnalyzerIndexComponent(analyzerIndexFlow))
        }
    }
}